const NrcMenuClose = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.18619 0.585771C3.40514 -0.195277 2.13881 -0.195277 1.35776 0.585771C0.576711 1.36682 0.576711 2.63315 1.35776 3.4142L12.6715 14.728L1.35776 26.0417C0.576711 26.8228 0.576711 28.0891 1.35776 28.8701C2.13881 29.6512 3.40514 29.6512 4.18619 28.8701L15.4999 17.5564L26.8136 28.87C27.5947 29.6511 28.861 29.6511 29.642 28.87C30.4231 28.089 30.4231 26.8227 29.642 26.0416L18.3284 14.728L29.642 3.41429C30.4231 2.63324 30.4231 1.36691 29.642 0.58586C28.861 -0.195188 27.5947 -0.195188 26.8136 0.58586L15.4999 11.8995L4.18619 0.585771Z"
      fill="#00355E"
    />
  </svg>
);
export default NrcMenuClose;
